// Fragment "siteBuilder (lot A)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    "siteBuilder.steps.template": "Modèle",
    "siteBuilder.steps.branding": "Branding",
    "siteBuilder.steps.content": "Contenu",
    "siteBuilder.steps.sections": "Sections",
    "siteBuilder.steps.address": "Adresse",
    "siteBuilder.steps.publish": "Publier",

    "siteBuilder.sections.story": "Mon parcours / À propos",
    "siteBuilder.sections.approach": "Approche",
    "siteBuilder.sections.services": "Services",
    "siteBuilder.sections.testimonials": "Témoignages",
    "siteBuilder.sections.blog": "Journal / Blog",
    "siteBuilder.sections.contact": "Contact",
    "siteBuilder.sections.stepTitle": "Sections affichées",
    "siteBuilder.sections.stepSubtitle": "Activez ou masquez les sections de votre page d'accueil.",
    "siteBuilder.sections.footerNote": "Le Hero (en-tête) et le pied de page sont toujours affichés.",

    "siteBuilder.title": "Construisez votre site",
    "siteBuilder.subtitle": "Choisissez un modèle, personnalisez-le, publiez.",

    "siteBuilder.template.title": "Choisissez un modèle",
    "siteBuilder.template.subtitle": "6 designs distincts. Vous pourrez tout personnaliser ensuite.",
    "siteBuilder.template.current": "Actuel",

    "siteBuilder.branding.title": "Votre identité visuelle",
    "siteBuilder.branding.subtitle": "Ajustez les couleurs, la tagline et le logo.",
    "siteBuilder.branding.color.primary": "Primaire",
    "siteBuilder.branding.color.accent": "Accent",
    "siteBuilder.branding.color.secondary": "Secondaire",
    "siteBuilder.branding.tagline.label": "Tagline",
    "siteBuilder.branding.tagline.placeholder": "Une phrase qui vous représente",
    "siteBuilder.branding.logo.label": "Logo",
    "siteBuilder.branding.logo.none": "Aucun",
    "siteBuilder.branding.logo.alt": "logo",
    "siteBuilder.branding.logo.upload": "Téléverser un logo",
    "siteBuilder.branding.logo.remove": "Retirer",

    "siteBuilder.toast.logoUploaded": "Logo téléversé",
    "siteBuilder.toast.uploadError": "Erreur upload",
    "siteBuilder.toast.previewUpdated": "Aperçu mis à jour",
    "siteBuilder.toast.error": "Erreur",
    "siteBuilder.toast.published": "Site publié !",

    "siteBuilder.content.title": "Votre contenu",
    "siteBuilder.content.subtitle": "Les textes principaux que vos visiteurs verront.",
    "siteBuilder.content.heroTitle.label": "Titre principal (Hero)",
    "siteBuilder.content.heroSubtitle.label": "Sous-titre",
    "siteBuilder.content.servicesText.label": "Présentation des services",

    "siteBuilder.address.title": "Adresse de votre site",
    "siteBuilder.address.subtitle": "Choisissez votre sous-domaine et, si vous le souhaitez, connectez un domaine personnalisé.",
    "siteBuilder.address.subdomain.label": "Votre adresse web (sous-domaine)",
    "siteBuilder.address.subdomain.placeholder": "moncabinet",
    "siteBuilder.address.renameNotice.title": "Changement d'adresse.",
    "siteBuilder.address.renameNotice.from": "Votre site passera de",
    "siteBuilder.address.renameNotice.to": "à",
    "siteBuilder.address.renameNotice.onPublish": "à la publication.",
    "siteBuilder.address.renameNotice.body": "Vos rendez-vous, disponibilités et clients sont conservés. L'ancienne adresse vous reste réservée et redirigera automatiquement vers la nouvelle — pensez tout de même à mettre à jour vos liens (réseaux sociaux, signature courriel).",
    "siteBuilder.address.customDomain.label": "Domaine personnalisé (optionnel)",
    "siteBuilder.address.customDomain.placeholder": "www.moncabinet.com",
    "siteBuilder.address.cname.title": "Comment connecter votre domaine ?",
    "siteBuilder.address.cname.before": "Créez un enregistrement CNAME pointant vers",
    "siteBuilder.address.cname.after": "Vous pouvez le faire plus tard.",

    "siteBuilder.publish.title": "Aperçu & publication",
    "siteBuilder.publish.subtitle": "Vérifiez l'aperçu live, puis publiez.",
    "siteBuilder.publish.urlLabel": "URL publique",
    "siteBuilder.publish.refreshPreview": "Rafraîchir l'aperçu",
    "siteBuilder.publish.previewIframeTitle": "Aperçu site",
    "siteBuilder.publish.publishButton": "Publier mon site",
    "siteBuilder.publish.openInTab": "Ouvrir dans un onglet",

    "siteBuilder.backToDashboard": "Retour au tableau de bord",
  },
  en: {
    "siteBuilder.steps.template": "Template",
    "siteBuilder.steps.branding": "Branding",
    "siteBuilder.steps.content": "Content",
    "siteBuilder.steps.sections": "Sections",
    "siteBuilder.steps.address": "Address",
    "siteBuilder.steps.publish": "Publish",

    "siteBuilder.sections.story": "My journey / About",
    "siteBuilder.sections.approach": "Approach",
    "siteBuilder.sections.services": "Services",
    "siteBuilder.sections.testimonials": "Testimonials",
    "siteBuilder.sections.blog": "Journal / Blog",
    "siteBuilder.sections.contact": "Contact",
    "siteBuilder.sections.stepTitle": "Displayed sections",
    "siteBuilder.sections.stepSubtitle": "Show or hide the sections on your homepage.",
    "siteBuilder.sections.footerNote": "The Hero (header) and footer are always displayed.",

    "siteBuilder.title": "Build your site",
    "siteBuilder.subtitle": "Choose a template, customize it, publish.",

    "siteBuilder.template.title": "Choose a template",
    "siteBuilder.template.subtitle": "6 distinct designs. You'll be able to customize everything afterwards.",
    "siteBuilder.template.current": "Current",

    "siteBuilder.branding.title": "Your visual identity",
    "siteBuilder.branding.subtitle": "Adjust the colors, tagline and logo.",
    "siteBuilder.branding.color.primary": "Primary",
    "siteBuilder.branding.color.accent": "Accent",
    "siteBuilder.branding.color.secondary": "Secondary",
    "siteBuilder.branding.tagline.label": "Tagline",
    "siteBuilder.branding.tagline.placeholder": "A phrase that represents you",
    "siteBuilder.branding.logo.label": "Logo",
    "siteBuilder.branding.logo.none": "None",
    "siteBuilder.branding.logo.alt": "logo",
    "siteBuilder.branding.logo.upload": "Upload a logo",
    "siteBuilder.branding.logo.remove": "Remove",

    "siteBuilder.toast.logoUploaded": "Logo uploaded",
    "siteBuilder.toast.uploadError": "Upload error",
    "siteBuilder.toast.previewUpdated": "Preview updated",
    "siteBuilder.toast.error": "Error",
    "siteBuilder.toast.published": "Site published!",

    "siteBuilder.content.title": "Your content",
    "siteBuilder.content.subtitle": "The main text your visitors will see.",
    "siteBuilder.content.heroTitle.label": "Main title (Hero)",
    "siteBuilder.content.heroSubtitle.label": "Subtitle",
    "siteBuilder.content.servicesText.label": "Services overview",

    "siteBuilder.address.title": "Your site's address",
    "siteBuilder.address.subtitle": "Choose your subdomain and, if you wish, connect a custom domain.",
    "siteBuilder.address.subdomain.label": "Your web address (subdomain)",
    "siteBuilder.address.subdomain.placeholder": "mypractice",
    "siteBuilder.address.renameNotice.title": "Address change.",
    "siteBuilder.address.renameNotice.from": "Your site will change from",
    "siteBuilder.address.renameNotice.to": "to",
    "siteBuilder.address.renameNotice.onPublish": "upon publishing.",
    "siteBuilder.address.renameNotice.body": "Your appointments, availability and clients are kept. The old address stays reserved for you and will automatically redirect to the new one — you should still update your links (social media, email signature).",
    "siteBuilder.address.customDomain.label": "Custom domain (optional)",
    "siteBuilder.address.customDomain.placeholder": "www.mypractice.com",
    "siteBuilder.address.cname.title": "How to connect your domain?",
    "siteBuilder.address.cname.before": "Create a CNAME record pointing to",
    "siteBuilder.address.cname.after": "You can do this later.",

    "siteBuilder.publish.title": "Preview & publish",
    "siteBuilder.publish.subtitle": "Check the live preview, then publish.",
    "siteBuilder.publish.urlLabel": "Public URL",
    "siteBuilder.publish.refreshPreview": "Refresh preview",
    "siteBuilder.publish.previewIframeTitle": "Site preview",
    "siteBuilder.publish.publishButton": "Publish my site",
    "siteBuilder.publish.openInTab": "Open in a tab",

    "siteBuilder.backToDashboard": "Back to dashboard",
  },
  es: {
    "siteBuilder.steps.template": "Plantilla",
    "siteBuilder.steps.branding": "Marca",
    "siteBuilder.steps.content": "Contenido",
    "siteBuilder.steps.sections": "Secciones",
    "siteBuilder.steps.address": "Dirección",
    "siteBuilder.steps.publish": "Publicar",

    "siteBuilder.sections.story": "Mi trayectoria / Sobre mí",
    "siteBuilder.sections.approach": "Enfoque",
    "siteBuilder.sections.services": "Servicios",
    "siteBuilder.sections.testimonials": "Testimonios",
    "siteBuilder.sections.blog": "Diario / Blog",
    "siteBuilder.sections.contact": "Contacto",
    "siteBuilder.sections.stepTitle": "Secciones mostradas",
    "siteBuilder.sections.stepSubtitle": "Activa u oculta las secciones de tu página de inicio.",
    "siteBuilder.sections.footerNote": "El Hero (cabecera) y el pie de página siempre se muestran.",

    "siteBuilder.title": "Construye tu sitio",
    "siteBuilder.subtitle": "Elige una plantilla, personalízala, publica.",

    "siteBuilder.template.title": "Elige una plantilla",
    "siteBuilder.template.subtitle": "6 diseños distintos. Podrás personalizarlo todo después.",
    "siteBuilder.template.current": "Actual",

    "siteBuilder.branding.title": "Tu identidad visual",
    "siteBuilder.branding.subtitle": "Ajusta los colores, el eslogan y el logo.",
    "siteBuilder.branding.color.primary": "Primario",
    "siteBuilder.branding.color.accent": "Acento",
    "siteBuilder.branding.color.secondary": "Secundario",
    "siteBuilder.branding.tagline.label": "Eslogan",
    "siteBuilder.branding.tagline.placeholder": "Una frase que te represente",
    "siteBuilder.branding.logo.label": "Logo",
    "siteBuilder.branding.logo.none": "Ninguno",
    "siteBuilder.branding.logo.alt": "logo",
    "siteBuilder.branding.logo.upload": "Subir un logo",
    "siteBuilder.branding.logo.remove": "Quitar",

    "siteBuilder.toast.logoUploaded": "Logo subido",
    "siteBuilder.toast.uploadError": "Error de subida",
    "siteBuilder.toast.previewUpdated": "Vista previa actualizada",
    "siteBuilder.toast.error": "Error",
    "siteBuilder.toast.published": "¡Sitio publicado!",

    "siteBuilder.content.title": "Tu contenido",
    "siteBuilder.content.subtitle": "Los textos principales que verán tus visitantes.",
    "siteBuilder.content.heroTitle.label": "Título principal (Hero)",
    "siteBuilder.content.heroSubtitle.label": "Subtítulo",
    "siteBuilder.content.servicesText.label": "Presentación de los servicios",

    "siteBuilder.address.title": "Dirección de tu sitio",
    "siteBuilder.address.subtitle": "Elige tu subdominio y, si lo deseas, conecta un dominio personalizado.",
    "siteBuilder.address.subdomain.label": "Tu dirección web (subdominio)",
    "siteBuilder.address.subdomain.placeholder": "miconsultorio",
    "siteBuilder.address.renameNotice.title": "Cambio de dirección.",
    "siteBuilder.address.renameNotice.from": "Tu sitio pasará de",
    "siteBuilder.address.renameNotice.to": "a",
    "siteBuilder.address.renameNotice.onPublish": "al publicar.",
    "siteBuilder.address.renameNotice.body": "Tus citas, disponibilidades y clientes se conservan. La antigua dirección permanece reservada para ti y redirigirá automáticamente a la nueva — de todos modos, actualiza tus enlaces (redes sociales, firma de correo).",
    "siteBuilder.address.customDomain.label": "Dominio personalizado (opcional)",
    "siteBuilder.address.customDomain.placeholder": "www.miconsultorio.com",
    "siteBuilder.address.cname.title": "¿Cómo conectar tu dominio?",
    "siteBuilder.address.cname.before": "Crea un registro CNAME que apunte a",
    "siteBuilder.address.cname.after": "Puedes hacerlo más tarde.",

    "siteBuilder.publish.title": "Vista previa y publicación",
    "siteBuilder.publish.subtitle": "Revisa la vista previa en vivo y luego publica.",
    "siteBuilder.publish.urlLabel": "URL pública",
    "siteBuilder.publish.refreshPreview": "Actualizar vista previa",
    "siteBuilder.publish.previewIframeTitle": "Vista previa del sitio",
    "siteBuilder.publish.publishButton": "Publicar mi sitio",
    "siteBuilder.publish.openInTab": "Abrir en una pestaña",

    "siteBuilder.backToDashboard": "Volver al panel",
  },
};
